<template>
    <div>
        <b-button-group size="sm" class="w-100">
            <b-button
                variant="table"
                v-if="checkActionAllow('select')"
                @click="selectItem(row.index)"
            >
                Отметить
            </b-button>

            <b-button
                variant="table"
                v-if="checkActionAllow('show')"
                @click="showItem(row.index)"
            >
                <i class="fas fa-eye"></i>
            </b-button>
            <!-- <b-button
                variant="table"
                v-if="checkActionAllow('delete') && !row.sent_at"
                @click="deleteItem(row.index)"
            >
                <i class="fas fa-trash text-danger"></i>
            </b-button> -->
        </b-button-group>
    </div>
</template>
<script>
    import {
        checkActionAllow
    } from '@/mixins'

    export default {
        props: {
            row: {type: Object, required: true},                                                // Row of table
            actionAllows: {type: Array, required: false, default: function () { return [] }},   // Array of rules for action allows
        },
        mixins: [
            checkActionAllow
        ],
        data() {
            return {
            }
        },
        methods: {
            showItem(index) {
                this.$emit('universalEmit', 'show', index)
            },
            selectItem(index) {
                this.$emit('universalEmit', 'selectItem', index)
            },
        }
    }
</script>

